var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.802734,
    y: 0.404297,
    width: 64.6328,
    height: 64.6328,
    rx: 32.3164,
    fill: "#645721"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0304 30.2175L33.1221 24.1282L39.2164 30.2224L42.7589 26.6774L33.1221 17.0381L23.4854 26.6749L27.0304 30.2175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.437 32.7214L20.9808 29.1776L24.5245 32.7214L20.9808 36.2651L17.437 32.7214Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.03 35.2241L33.1217 41.3158L39.2159 35.2216L42.761 38.7617L42.7585 38.7642L33.1217 48.4034L23.4849 38.7691L23.48 38.7642L27.03 35.2241Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7134 32.7224L45.2571 29.1786L48.8009 32.7224L45.2571 36.2661L41.7134 32.7224Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7161 32.7196L33.1215 29.1225L30.4634 31.7807L30.1562 32.0854L29.5269 32.7146L29.522 32.7196L29.5269 32.727L33.1215 36.3191L36.7161 32.722L36.7186 32.7196H36.7161Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.bdba7f3a8d3e7b93733cf0cb5f05537c.svg";
export { ForwardRef as ReactComponent };